import axiosPlugin from '@/plugins/axios'

export default {
  install: (app) => {
    app.use(axiosPlugin)
  }
}
